import { combineReducers } from "@reduxjs/toolkit";
import { AuthReducer } from "./auth/Reducers";
import { AutorizacionReducer } from "./autorizacion/Reducers";
import { AseguradoReducer } from "./asegurado/Reducers";
import { PrestadorReducer } from "./prestador/Reducers";
import { ProcedimientoReducer } from "./procedimiento/Reducers";
import { PrecertificacionReducer } from "./precertificacion/Reducers";
import { CatalogoReducer } from "./catalogo/Reducers";
import { VoucherReducer } from "./voucher/Reducers";
import { IngresoReducer } from "./ingreso/Reducers";

const appReducer = combineReducers({
  auth: AuthReducer,
  autorizacion: AutorizacionReducer,
  asegurado: AseguradoReducer,
  prestador: PrestadorReducer,
  procedimiento: ProcedimientoReducer,
  precertificacion: PrecertificacionReducer,
  catalogo: CatalogoReducer,
  voucher: VoucherReducer,
  ingreso: IngresoReducer,
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

export default rootReducer;